import { DeleteModalService } from './../../services/delete-modal.service';
import { DeleteModalComponent } from './../../../shared/delete-modal/delete-modal.component';
import { ProductCategoriesModalComponent } from './../../../shared/product-categories-modal/product-categories-modal.component';
import { MasterService } from './../../services/master.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-product-categories',
  templateUrl: './product-categories.component.html',
  styleUrls: ['./product-categories.component.scss']
})
export class ProductCategoriesComponent implements OnInit {

  public productcategories: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchTxt: any;
  placeHolder: any = 'Search by Product Category';

  // File upload properties
  public isFile = false;
  public uploadedFile: File | null = null;
  public fileType = '';
  public masterType = 'product_categories';

  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;

  public childMessage = 'listing_pagination';
  bool = false;
  constructor(public masterservice: MasterService, public dialog: MatDialog, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) { }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.products_categories.view'] == 1 || roles['more.products_categories.add'] == 1 || roles['more.products_categories.edit'] == 1 || roles['more.products_categories.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.products_categories.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.products_categories.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.products_categories.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getProductCategoriesData();
  }

  getProductCategoriesData() {

    // let page = 1;
    this.masterservice.getIndex('/product_categories/index', this.filter).subscribe(res => {

      const newData = {
        body_part_name: '',
        implant_name: '',
        name: ''
      };

      // @ts-ignore
      this.productcategories = res.data.items;
      if (this.productcategories.length < this.per_page) {
        for ( let i = 0; i < this.itemToBePushed ; i++) {
          this.productcategories.push(newData);
        }
      }

      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page      = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;

      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });

  }


  openDialog(): void {
    const dialogRef = this.dialog.open(ProductCategoriesModalComponent, {
      minWidth: '50vw',
      minHeight: '20vh',
      disableClose: true
    }).afterClosed().subscribe(() => this.getProductCategoriesData());
  }

  editDialog(i) {
    const editId = this.productcategories[i].id;
    const encID = this.productcategories[i].enc_id;
    // tslint:disable-next-line:triple-equals
    if (editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(ProductCategoriesModalComponent, {
        minWidth: '50vw',
        minHeight: '20vh',
        disableClose: true,
        data: {
          edit: {
            editID: editId,
            encryId: encID
          }
        }
      }).afterClosed().subscribe(() => this.getProductCategoriesData());
    }
  }

  doSearch(): void {
    if (this.searchTxt && this.searchTxt.trim() !== '') {
      Object.assign(this.filter, {search: { type: 'str', field: 'product_categories.name', text: this.searchTxt}});
    } else {
      // Remove search filter if search text is empty
      delete this.filter.search;
    }
    this.getProductCategoriesData();
  }

   doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getProductCategoriesData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getProductCategoriesData();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  deleteDialog(i): void {
    this.deleteModalService.openModal({
      token: localStorage.getItem('token'),
      id: this.productcategories[i].id,
      encId: this.productcategories[i].enc_id,
      deleteUrl: '/product_categories/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getProductCategoriesData();
    });
  }

  // File upload methods
  isDragOver(): boolean {
    return false; // Implement drag over logic if needed
  }

  dropFile(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

  dragOverFile(event: DragEvent): void {
    event.preventDefault();
  }

  dragLeaveFile(event: DragEvent): void {
    event.preventDefault();
  }

  dragEndFile(event: DragEvent): void {
    event.preventDefault();
  }

  browseFile(event: Event): void {
    const input = document.getElementById('file-input') as HTMLInputElement;
    input.click();
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFile(input.files[0]);
    }
  }

  private handleFile(file: File): void {
    this.uploadedFile = file;
    this.isFile = true;
    this.fileType = 'product_categories';
  }

  resetFile(): void {
    this.uploadedFile = null;
    this.isFile = false;
    this.fileType = '';
    const input = document.getElementById('file-input') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

  onSubmit(): void {
    if (this.uploadedFile && this.fileType) {
      // Implement file upload logic here
      console.log('Uploading file:', this.uploadedFile.name);
      // You can add actual upload logic here
    }
  }

  downloadBulkUploadTemplate(masterType: string): void {
    // Implement template download logic here
    console.log('Downloading template for:', masterType);
    // You can add actual download logic here
  }

}

